import React from 'react'
import * as fn from '../../../../helper/uiFunctions';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const DocAddChoice = (props) => {
    const { formObject, viewData, rowID, reloadSearch } = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    const isRO = formObject.getValueFromKey(viewData, "dataList.isRO", "");
    const actionId = formObject.getValueFromKey(viewData, "dataList.actionId", "");
    const catId = formObject.getValueFromKey(viewData, "dataList.valLCat", "");

    //build the url for link
    // const url = fn.getShowDocumentLink(viewData.dataList.valLDT, viewData.val, "", 1,
    //     formObject.docModule, formObject.docView);

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch();
    }
    
    const onAddClick = (e) => {
        let customAction = { actionId: actionId, skipMasterKey: 1, containerKey: "popup" };

        customAction.onModalClose = onPopupClose;
        customAction["actionParam"] = { "ctgId": catId };
        customAction["actionName"] = formObject.getValueFromKey(viewData, "dataList.actionName", "");

        if (customAction.actionId) formObject.onFormAction(customAction, rowID, "");
    }

    const renderAction = () => {
        // console.log("is isRO", isRO)
        if(!isRO || fn.compareNumber(isRO, 0))
        {
            return (
                <button className="uiActionAdd uiSpacerL2 uiContentCenter" onClick={onAddClick}></button>
            )
        }

        return (
            <span><SarasTrans value = "Readonly"/></span>
        );
    }

    return (
        <div className="saras-cell">
            <div className={valCssClass}>
                <span className="uiSpacerR2">{viewData.valF}</span>
                {renderAction()}
            </div>
        </div>
    )
}

export default DocAddChoice